import { render } from "./P033.vue?vue&type=template&id=c65e782e&scoped=true"
import script from "./P033.vue?vue&type=script&lang=js"
export * from "./P033.vue?vue&type=script&lang=js"

import "./P033.vue?vue&type=style&index=0&id=c65e782e&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c65e782e"]])

export default __exports__